
import { useEffect, useState } from 'react'
import CtaButton from '../../components/ctaButton/CtaButton'
import './style.scss'
import { userStateData } from '../../data/userStateData'
import { useAppSelector } from '../../redux/hooks'
import { ChatInteractions, UserDetails } from '../../server/types'
import { getProfilePicPath } from '../../constants/instructorConstants'
import { PAGE_URLS } from '../../constants/hrefLinks'
import { InteractionStatus } from '../../types/types'
import { getBookingStatusLabel } from '../../utils/RetrieveStrings'
import ProfileIcon from '../../components/profileIcon/ProfileIcon'
import AdBannerBasic from '../../components/adBannerBasic/AdBannerBasic'


function DashboardContentArea() {
	const [interactios, setInteractions] = useState<ChatInteractions[]>([])
	const [savedInstructors, setSavedInstructors] = useState<UserDetails[]>([])
	const [bookingDetails, setBookingDetails] = useState<ChatInteractions[]>([])
	const [userDataLoaded, setUserDataLoaded] = useState<boolean>(false)
	// const [completeInteractionCount, setCompleteInteractionCount] = useState<number>(0)

	const dataLoadRequestFinished: boolean = useAppSelector(state => state.user.dataLoadRequestFinished)

	// Setup test values
	useEffect(() => {
		if (dataLoadRequestFinished === true) {
			// setInteractions(userStateData.getInteractions(4))
			const interactions: ChatInteractions[] = userStateData.getInteractions()
			let activeInteractions: ChatInteractions[] = []
			// let completeCount: number = 0
			interactions.forEach((interaction: ChatInteractions) => {
				if (interaction.status === InteractionStatus.ACTIVE || interaction.status === InteractionStatus.REVIEW) {
					activeInteractions.push(interaction)
				}
				// } else {
				// 	completeCount += 1
				// }
			})
			setInteractions(activeInteractions)
			setBookingDetails(userStateData.getInteractions())
			// setCompleteInteractionCount(completeCount)

			setSavedInstructors(userStateData.getLikedInstructorDetails())
			setUserDataLoaded(true)
			// setBookingDetails([])
		}
	}, [dataLoadRequestFinished])

	return (
		<div className='dashboard-content-area-wrap'>
			{bookingDetails.length == 0 &&
				<AdBannerBasic
					message='Get your first session for free, Choose an instructor - Upload videos - Book now. No payment required'
				/>
			}
			<div className='dashboard-content-area-small-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-chat.svg`}
							alt='Chat symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Chats</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{
						// chats.length === 0 ?
						interactios.length === 0 ?
							<span>No ongoing chats</span>
							:
							// chats.map((chat: DashboardChat, index: number) => 
							interactios.map((interactios: ChatInteractions, index: number) => 
								<a 
									className='dashboard-content-area-card-chat-wrap'
									key={`chatItem${index}`}
									href={`chat?id=${interactios.id}`}
								>
									<img
										className='dashboard-content-area-card-chat-img'
										alt='profile thumbnail'
										src={interactios.otherUserDetails?.profile_pics ? getProfilePicPath(interactios.otherUserDetails?.profile_pics, 0) : undefined}
									/>
									<div className='dashboard-content-area-card-chat-details-wrap'>
										<div className='dashboard-content-area-card-chat-name'>{interactios.otherUserDetails?.name}</div>
										<div className='dashboard-content-area-card-chat-extract'>...</div>
									</div>
								</a>
							)
						}
					</div>
					{/* <div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View All Chats'
							size='large'
							onClick={() => console.log('View All Chats clicked')}
						/>
					</div> */}
				</div>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-profile.svg`}
							alt='Profile symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Profile</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{userDataLoaded ? 
							<>
								<div className='dashboard-content-area-card-profile-name-wrap'>
									<ProfileIcon
										imgSrc={userStateData.getUserIconUrl()}
									/>	
									<div className='dashboard-content-area-card-profile-name'>{userStateData.getUsersName()}</div>
								</div>
								<div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Age</div>
									{userStateData.getAge()}
								</div>
								<div className='dashboard-content-area-card-profile-details dashboard-content-area-card-profile-details-extra-base'>
									<div className='dashboard-content-area-card-profile-details-label'>Language</div>
									English
								</div>
								<div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Phone</div>
									{userStateData.getPhoneNumber()}
								</div>
								<div className='dashboard-content-area-card-profile-details dashboard-content-area-card-profile-details-extra-base'>
									<div className='dashboard-content-area-card-profile-details-label'>Email</div>
									{userStateData.getEmail()}
								</div>
								{/* <div className='dashboard-content-area-card-profile-details dashboard-content-area-card-profile-details-extra-base'>
									<div className='dashboard-content-area-card-profile-details-label'>Completed Lessons</div>
									{completeInteractionCount} - Complete {3 - completeInteractionCount} more for a free lesson
								</div> */}
								{/* <div className='dashboard-content-area-card-profile-details'>
									<div className='dashboard-content-area-card-profile-details-label'>Card Details</div>
									**** **** **** 1234
								</div> */}
							</>:<>Loading...</>
						}
					</div>
					<div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View Profile'
							size='large'
							onClick={() => window.location.replace(PAGE_URLS.DASHBOARD_PROFILE)}
						/>
					</div>
				</div>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-saved.svg`}
							alt='Saved symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Saved Instructors</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{savedInstructors.length === 0 ?
							<span>No Saved Instructors</span>
							:
							savedInstructors.map((instructor: UserDetails, index: number) => 
								<a 
									className='dashboard-content-area-card-chat-wrap'
									key={`chatItem${index}`}
									href={`${PAGE_URLS.INSTRUCTOR}?id=${instructor.id}`}
								>
									<img
										className='dashboard-content-area-card-chat-img'
										alt='profile thumbnail'
										src={instructor?.profile_pics ? getProfilePicPath(instructor?.profile_pics, 0) : undefined}
									/>
									<div className='dashboard-content-area-card-chat-details-wrap'>
										<div className='dashboard-content-area-card-chat-name'>{instructor?.name}</div>
										<div className='dashboard-content-area-card-chat-extract'>...</div>
									</div>
								</a>
							)
						}
					</div>
					{/* <div
						className='dashboard-content-area-card-bottom-wrap'
					>
						<CtaButton
							label='View All Saved Instructors'
							size='large'
							onClick={() => console.log('View All Saved Instructors clicked')}
						/>
					</div> */}
				</div>
			</div>
			<div className='dashboard-content-area-wide-card-wrap'>
				<div className='dashboard-content-area-card'>
					<div className='dashboard-content-area-card-title-wrap'>
						<img
							className='dashboard-content-area-card-title-icon'
							src={`/imgs/icons/dashboard/icon-dashboard-booking.svg`}
							alt='Booking symbol'
						/>
						<div className='dashboard-content-area-card-title-label'>Booking Details</div>
					</div>
					<div
						className='dashboard-content-area-card-content'
					>
						{bookingDetails.length === 0 ?
							<span>No Bookings</span>
							:
							bookingDetails.map((booking: ChatInteractions, index: number) => 
								<a 
									className='dashboard-content-area-card-chat-wrap'
									key={`chatItem${index}`}
									href={`chat?id=${booking.id}`}
								>
									<img
										className='dashboard-content-area-card-chat-img'
										alt='profile thumbnail'
										src={booking.otherUserDetails?.profile_pics ? getProfilePicPath(booking.otherUserDetails?.profile_pics, 0) : undefined}
									/>
									<div className='dashboard-content-area-card-chat-details-wrap'>
										<div className='dashboard-content-area-card-chat-name'>{booking.otherUserDetails?.name}</div>
									</div>
									<div className='dashboard-content-area-booking-status'>
										{getBookingStatusLabel(booking.status)}
									</div>
									<div className='dashboard-content-area-booking-cost'>
										$ {(parseFloat(booking.price ? booking.price : '0') / 100).toFixed(2)}
									</div>
								</a>
							)
						}
					</div>
				</div>
			</div>
		</div>
	)
}

export default DashboardContentArea
